import { useTranslation } from "react-i18next";

interface StepIndicatorProps {
  currentStep: number;
  totalSteps: number;
  stepLabels?: string[];
}

export function StepIndicator({ currentStep, totalSteps, stepLabels }: StepIndicatorProps) {
  const { t } = useTranslation();
  return (
    <div className="w-full px-4 py-4 bg-background border-b">
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm font-medium text-foreground">
          {t("measurementExtra.stepProgress", { current: currentStep, total: totalSteps })}
        </span>
        <span className="text-xs text-muted-foreground">
          {Math.round((currentStep / totalSteps) * 100)}%
        </span>
      </div>
      <div className="w-full bg-muted rounded-full h-2">
        <div
          className="bg-primary h-2 rounded-full transition-all duration-300"
          style={{ width: `${(currentStep / totalSteps) * 100}%` }}
        />
      </div>
      {stepLabels && stepLabels[currentStep - 1] && (
        <div className="mt-2 text-xs text-muted-foreground text-center">
          {stepLabels[currentStep - 1]}
        </div>
      )}
    </div>
  );
}
